<template>
  <div class='EnbSuggestion'>
    <div class="label">Você pode gostar...</div>
    <div class="cont-itens">
      <enb-item01
      v-for="(i, key) in produtos"
      :key="key"
      :data="i"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EnbItem01 from './EnbItem01'
export default {
  name: 'EnbSuggestion',
  components: { EnbItem01 },
  data () {
    return {
      produtos: []
    }
  },
  computed: {
    ...mapGetters(['ItemSelected01'])
  },
  methods: {
    ...mapActions(['GetSuggestion'])
  },
  created () {
    this.GetSuggestion({ category: this.ItemSelected01.categoria, prodid: this.ItemSelected01.id })
      .then(res => this.produtos = res)
  }
}
</script>

<style scoped>
.EnbSuggestion {
  width: 96%;
  padding: 2%;
}

.label {
  font-size: 20px;
}

.cont-itens {
  width: 60%;
  display: flex;
  justify-content: center;
  margin: auto;
}

@media (max-width: 500px) {
  .cont-itens {
    width: 100%;
    flex-wrap: wrap;
    overflow: auto;
    padding-top: 5%;
    padding-bottom: 20%;
  }
}
</style>
